const classes = [
    {label: "feca",  picture: 'feca.webp' },
    {label: "osamodas", picture: 'osamodas.webp' },
    {label: "enutrof", picture: 'enutrof.webp' },
    {label: "sram", picture: 'sram.webp' },
    {label: "xelor", picture: 'xelor.webp' },
    {label: "ecaflip", picture: 'ecaflip.webp' },
    {label: "sacrieur", picture: 'sacrieur.webp' },
    {label: "iop", picture: 'iop.webp' },
    {label: "crâ", picture: 'cra.webp' },
    {label: "sadida", picture: 'sadida.webp' },
    {label: "zobal", picture: 'zobal.webp' },
    {label: "pandawa", picture: 'pandawa.webp' },
    {label: "steamer", picture: 'steamer.webp' },
    {label: "eliotrope", picture: 'eliotrope.webp' },
    {label: "huppermage", picture: 'huppermage.webp' },
    {label: "eniripsa", picture: 'eniripsa.webp' },
    {label: "roublard", picture: 'roublard.webp' },
]

export default classes
